import { useGet } from '../../HttpClient';
import { tenantHierarchyBaseUrl } from '../BaseUrls';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';

const pillarCode = "tms";
 
export function useAggregatedConfigRule({ ouId }: { ouId: string }) {
  const get = useGet(true, pillarCode);
  const getAggregatedRulesForOu = async (ouId: string) =>
    get<any[]>(`${tenantHierarchyBaseUrl}/organisation-units/${ouId}/aggregated-rules`);

  return useQueryWithErrorHandling({
    queryKey: ['aggregated-config-rule', ouId],
    queryFn: async () => await getAggregatedRulesForOu(ouId),
    enabled: !!ouId,
  });
}
